<!-- eslint-disable vue/multi-word-component-names -->
<template>
  <div
    id="landingPage"
    :style="{ 'background-image': 'url(' + bg + ')' }"
    class="d-flex align-items-center justify-content-center w-100 h-100"
  >
    <div class="row container h-100 align-items-end">
      <div class="d-none d-md-block col-md-6">
        <img
          :src="'/static/pictures/i-phone-x-hand-mockup.png'"
          alt=""
          class="w-100 img-mock"
        />
      </div>
      <!-- message size xs => md -->
      <div
        class="d-block d-lg-none col-xs-12 col-md-6 align-self-center content text-start sm"
      >
        <img src="/static/pictures/BaanRueJai.svg" alt="" class="logo" />
        <h1>ยินดีต้อนรับเข้าสู่บ้านรู้ใจ</h1>
        <div class="detail">
          แอปพลิเคชั่นเพื่อการอยู่อาศัยที่ “รู้ใจ”
          เสมือนผู้ช่วยส่วนตัวคุณภาพที่ช่วยดูแลให้การอยู่อาศัยของทุกคนในบ้านสะดวกสบายขึ้น
          สามารถดาวน์โหลดได้แล้ววันนี้ที่
        </div>
        <div class="row">
          <div class="col">
            <a :href="ios">
              <img
                :src="'/static/pictures/download-app-store.png'"
                alt=""
                class="img-store"
              />
            </a>
            <a :href="android">
              <img
                :src="'/static/pictures/download-google-play.png'"
                alt=""
                class="img-store"
              />
            </a>
          </div>
        </div>
        <div class="footer">*สำหรับสมาชิกครอบครัว SC Family</div>
      </div>
      <!-- message size lg => xl -->
      <div
        class="d-none d-lg-block col-xs-12 col-md-6 align-self-center content text-start"
      >
        <img src="/static/pictures/BaanRueJai.svg" alt="" class="logo" />
        <h1>ยินดีต้อนรับเข้าสู่บ้านรู้ใจ</h1>
        <div class="detail">
          แอปพลิเคชั่นเพื่อการอยู่อาศัยที่ “รู้ใจ”
          เสมือนผู้ช่วยส่วนตัวคุณภาพที่ช่วยดูแลให้การอยู่อาศัยของทุกคนในบ้านสะดวกสบายขึ้น
          สามารถดาวน์โหลดได้แล้ววันนี้ที่
        </div>
        <div class="row">
          <div class="col">
            <a :href="ios">
              <img
                :src="'/static/pictures/download-app-store.png'"
                alt=""
                class="img-store"
              />
            </a>
            <a :href="android">
              <img
                :src="'/static/pictures/download-google-play.png'"
                alt=""
                class="img-store"
              />
            </a>
          </div>
        </div>
        <div class="footer">*สำหรับสมาชิกครอบครัว SC Family</div>
      </div>
    </div>
  </div>
</template>

<script
  async
  src="https://www.googletagmanager.com/gtag/js?id=UA-126808151-1"
></script>

<script>
window.dataLayer = window.dataLayer || [];
function gtag() {
  dataLayer.push(arguments);
}
gtag("js", new Date());
gtag("config", "UA-126808151-1");

export default {
  name: 'LandingPage',
  data() {
    return {
      msg: "App is healty!",
      bg: "/static/backgrounds/bg-landing.png",
      android:
        "https://play.google.com/store/apps/details?id=com.fireoneone.baanruejai",
      ios: "https://itunes.apple.com/th/app/baan-ruejai/id1375938415?mt=8"
    };
  },
  mounted() {

    // Environment Vars
    const { NODE_ENV } = process.env
    
    // Validate Environment
    if (NODE_ENV == 'local') {
      this.$router.push('/admins/logins')
    }
    else {
      window.location = "https://www.scasset.com/baanruejai"
    }
  }
};
</script>

<style scoped>
h1 {
  font-size: 36px;
  font-weight: bold;
  font-style: normal;
  font-stretch: normal;
  line-height: 1.29;
  letter-spacing: -0.2px;
  color: #e27024;

  margin-bottom: 20px;
}
.sm h1 {
  font-size: 28px;
}
#landingPage {
  background-position: top;
  background-size: cover;
  overflow-x: auto;
}
.detail {
  font-size: 24px;
  font-weight: 500;
  font-style: normal;
  font-stretch: normal;
  line-height: 1.5;
  letter-spacing: normal;
  color: #4a4a4a;

  margin-bottom: 40px;
}
.sm .detail {
  font-size: 20px;
}
.footer {
  font-size: 14px;
  font-weight: 500;
  font-style: normal;
  font-stretch: normal;
  line-height: 1.36;
  letter-spacing: -0.1px;
  color: #000000;
  margin-top: 10px;
}
.logo {
  width: 150px;
  margin-bottom: 30px;
}
.img-mock {
  object-fit: contain;
  max-height: 90vh;
  max-width: 500px;
}
.img-store {
  max-width: 120px;
}
</style>
